<template>
  <div class="row align-items-center full-height">
    <div class="col full-height angled-11deg">
      <div class="instructions">
        <h2>Confirm User</h2>
        <p>Please enter confirmation code and email address to finish signing up.</p>
      </div>
      <small class="copyright left">iPro<span class="registeredTrademark">&reg;</span> Systems &copy; {{ new Date().getFullYear() }}</small>
    </div>
    <component :is="step"></component>
  </div>
</template>

<script>
export default {
  name: 'signup',
  data () {
    return {
    }
  },
  components: {
    'createNewPassword': () => import('./createNewPassword'),
    'confirm': () => import('./confirmUser')
  },
  computed: {
    step () {
      if (this.$route.params.step) {
        return this.$route.params.step
      } else {
        return 'createNewPassword'
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
@import '../../less/elements/color.less';
@import '../../less/utils/mixins.less';
@import '../../less/components/auth.less';
.authModule {
  max-width: 350px;
  position: absolute;
  top: -110px;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/challengeBase.vue